<template>
    <div>
        <div class="gallery-buy">
            <v-container grid-list-lg :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'pa-3': $vuetify.breakpoint.mdAndUp}">
                <v-layout row wrap :class="{'ma-0': $vuetify.breakpoint.smAndDown}">
                    <v-flex xs12 md4 :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
                        <slot name="imagesAndVideos"></slot>
                    </v-flex>

                    <v-flex xs12 md8 :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'pl-1': $vuetify.breakpoint.mdAndUp}">
                        <slot name="productTitle"></slot>
                        <slot name="averageRating"></slot>

                        <v-layout row wrap>
                            <v-flex xs12 md6 class="pr-3">
                                <slot name="productLongDescriptionShortened"></slot>
                                <slot name="productSpecificationShort"></slot>
                                <slot name="productHighlightedReview"></slot>
                            </v-flex>

                            <v-flex xs12 md6>
                                <slot name="productSidebar"></slot>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <v-layout row wrap>
            <v-flex xs12>
                <slot name="buyOptions"></slot>
            </v-flex>
        </v-layout>

        <v-container fluid class="primary-transparent-1 elevation-lighten-1">
            <v-container>
                <v-layout row wrap>
                    <v-flex xs12>
                        <slot name="productSubTitle"></slot>
                    </v-flex>
                    <v-flex md6 xs12>
                        <slot name="productLongDescription"></slot>
                    </v-flex>
                    <v-flex md6 xs12>
                        <slot name="productSpecification"></slot>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-container>

        <slot name="productVideo"></slot>

        <v-layout row wrap>
            <v-flex xs12>
                <slot name="productReviews"></slot>

                <slot name="upsells"></slot>
                <slot name="crosssells"></slot>
            </v-flex>
        </v-layout>

        <slot name="questionsList"/>

        <slot name="viewStatistics"></slot>
    </div>
</template>

<script>
export default {
    name: 'ProductTemplate',
};
</script>